import React, { Component } from 'react';
import { connect } from 'react-redux';
import Table from '../UI/Table/Table';
import Blank from '../../hoc/Blank/Blank';
import AssignDliveryModal from '../AssignDeliveryModal/AssignDeliveryModal';
import Modal from '../UI/Modal/Modal';
import ReactInterval from 'react-interval';
import classes from './DriverStatus.css';
import * as actions from '../../store/actions/index';

class DriverStatus extends Component {
 state = {
     driverId:0,
     showModal:false
 }
  componentDidMount() {
    window.scrollTo(0, 0);
    this.props.onGetDrivers();
  }

  driverClick = (e) => {
    let driverId = e.currentTarget.getAttribute('oid');
    for (let k in this.props.drivers) {
        if (this.props.drivers[k].driverId == driverId) {
            if (this.props.drivers[k].status == 'ready') {
                this.setState({driverId: driverId,showModal: true});
            }
        }
    }
  }

  deliveryChanged = (did) => {
this.setState({showModal: false});
this.props.onAssignDriverDelivery(did,this.state.driverId);
  }

  cancelAssignDelivery = () => {
    this.setState({showModal: false});
  }

    render() {
                if (this.props.drivers) {
            let pl = "5px";
            var data = [];
            for (let k in this.props.drivers) {
                let entry = this.props.drivers[k];
                let hightlight = false;
                if (entry.status == 'ready') {
                    hightlight = true;
                }
                data.push({
                    oid: entry.driverId,highlight: hightlight, data: [
                        {
                            value: entry.carNumber,
                            style: { paddingLeft: pl }
                        },
                        {
                            value: entry.name,
                            style: { paddingLeft: pl }
                        },
                        {
                            value: entry.phone,
                            style: { paddingLeft: pl }
                        },
                        {
                            value: entry.numberOfBags,
                            style: { paddingLeft: pl }
                        },
                        {
                            value: entry.status,
                            style: { paddingLeft: pl }
                        },
                        {
                            value: entry.ordersRemaining,
                            style: { paddingLeft: pl }
                        },
                        {
                            value: entry.currentOrder,
                            style: { paddingLeft: pl }
                        }
                    ]
                }
                )
            }



            var header = [
                {
                    name: "Car #",
                    style: { paddingLeft: pl }
                },
                {
                    name: "Name",
                    style: { paddingLeft: pl }
                },
                {
                    name: "Phone",
                    style: { paddingLeft: pl }
                },
                {
                    name: "# Bags",
                    style: { paddingLeft: pl }
                },
                {
                    name: "Status",
                    style: { paddingLeft: pl }
                },
                {
                    name: "Orders",
                    style: { paddingLeft: pl }
                },
                {
                    name: "Current Order",
                    style: { paddingLeft: pl }
                }
            ];

            return (

                <div className={classes.DriverStatus}>  
                    <ReactInterval timeout={10000} enabled={true}
          callback={() => this.props.onGetDrivers()} />        
                    <Modal show={this.state.showModal} modalClosed={this.cancelAssignDelivery}>        
                    <AssignDliveryModal driverId={this.state.driverId}
                        deliveryChanged={this.deliveryChanged} cancelAssignDelivery={this.cancelAssignDelivery} />
                    </Modal> 
                    <Table header={header} data={data} editPopupHandler={this.driverClick}></Table>
                </div>
            );
        }
        else {
            return (<Blank></Blank>);
        }
    }

}


const mapStateToProps = state => {
  return {
    drivers: state.orders.drivers
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onGetDrivers: () => dispatch(actions.getDrivers()),
    onAssignDriverDelivery: (deliveryId,driverId) => dispatch(actions.assignDriverDelivery(deliveryId,driverId))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DriverStatus);


// WEBPACK FOOTER //
// ./src/components/DriverStatus/DriverStatus.js